import React, { useState } from "react";
import { FiUpload, FiFileText } from "react-icons/fi";
import { toast } from "react-toastify";
import C1 from "../../assets/images/C1.jpeg";
import C2 from "../../assets/images/C2.jpeg";
import C3 from "../../assets/images/C3.jpeg";
import C4 from "../../assets/images/C4.jpeg";
import ContactUsMap from "../../components/ContactUsMap/ContactUsMap";
import axiosInstance from "../../components/Hooks/axiosInstance";
import SetTitle from "../../components/SetTitle";
import styles from "./ContactUs.module.scss";

const ContactUs = () => {
	SetTitle("Contact Us");

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [number, setNumber] = useState("");
	const [address, setAddress] = useState("");
	const [message, setMessage] = useState("");

	const [uploading, setUploading] = useState(false);
	const [vacancyFile, setVacancyFile] = useState(null);
	const [title, setTitle] = useState(null);
	const [selectedFile1, setSelectedFile1] = useState(null);
	const [selectedFile2, setSelectedFile2] = useState(null);
	const [selectedFile3, setSelectedFile3] = useState(null);
	const [selectedFile4, setSelectedFile4] = useState(null);

	const handleChangeFile = ({ file, title }) => {
		if (!file) return;
		if (title === "Teacher") {
			setSelectedFile1(file);
			setSelectedFile2(null);
			setSelectedFile3(null);
			setSelectedFile4(null);
		} else if (title === "Receptionist") {
			setSelectedFile2(file);
			setSelectedFile1(null);
			setSelectedFile3(null);
			setSelectedFile4(null);
		} else if (title === "Attendant") {
			setSelectedFile3(file);
			setSelectedFile1(null);
			setSelectedFile2(null);
			setSelectedFile4(null);
		} else if (title === "Security Guard") {
			setSelectedFile4(file);
			setSelectedFile1(null);
			setSelectedFile2(null);
			setSelectedFile3(null);
		}
		setTitle(title);
		setVacancyFile(file);
	};

	const handelSend = () => {
		if (!name || !email || !number || !address) {
			return toast.warn("Name, email, phone and address are required fields...");
		}
		setUploading(true);

		axiosInstance
			.post(`/contact-us/create`, {
				name,
				email,
				phone: number,
				address,
				message,
			})
			.then(({ data }) => {
				toast.success(data?.msg || data?.message || "Contact us form submitted successfully. We will reach you soon...");
				setName("");
				setEmail("");
				setMessage("");
				setAddress("");
				setNumber("");
			})
			.catch((err) => {
				console.log(err);
				toast.error(err?.response?.data?.msg || err?.response?.data?.message || "Something went wrong...");
			})
			.finally(() => setUploading(false));
	};

	const handleVacancyUpload = () => {
		if (!vacancyFile) {
			return toast.warn("Please select a file to upload...");
		}
		setUploading(true);

		const formData = new FormData();
		formData.append("cv", vacancyFile);
		formData.append("title", title);

		axiosInstance
			.post(`/vacancy/create`, formData)
			.then(({ data }) => {
				toast.success(data?.msg || data?.message || "Vacancy uploaded successfully...");
				setVacancyFile(null);
				setTitle(null);
				setSelectedFile1(null);
				setSelectedFile2(null);
				setSelectedFile3(null);
				setSelectedFile4(null);
			})
			.catch((err) => {
				console.log(err);
				toast.error(err?.response?.data?.msg || err?.response?.data?.message || "Something went wrong...");
			})
			.finally(() => setUploading(false));
	};

	return (
		<div className={styles.ContactUs}>
			<h2>Contact Us</h2>

			<div className={styles.Container1}>
				<ContactUsMap />
			</div>

			<div className={styles.Container2}>
				<div className={styles.PartnerContainer}>
					<h3>Contact Us</h3>
					<div className={styles.FormContainer}>
						<div className={styles.InputContainer}>
							<label>Name</label>
							<input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter your name" />
						</div>
						<div className={styles.InputContainer}>
							<label>Email</label>
							<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" />
						</div>
						<div className={styles.InputContainer}>
							<label>Phone</label>
							<input type="number" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="Enter 10-digit number" />
						</div>
						<div className={styles.InputContainer}>
							<label>Address</label>
							<input type="text" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter your address" />
						</div>
						<div className={styles.InputContainer}>
							<label>Message</label>
							<textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Write your message here..."></textarea>
						</div>
						{uploading ? <button style={{ cursor: "none" }}>Uploading...</button> : <button onClick={handelSend}>Send</button>}
					</div>
				</div>
			</div>

			<div className={styles.Container3}>
				<h3>Careers</h3>

				<div className={styles.LeftContainer}>
					<div className={styles.Left}>
						<h4>vacancy for the post of Teacher's</h4>
						<span></span>
						<ul>
							<li>Graduate/ Post Graduate</li>
							<li>NTT/PTT/IMTTI</li>
							<li>Minimum Experience & Skill Requirements</li>
							<li>1-2 Years of working experience in classroom Management</li>
							<li>Knowledge of MS- Office</li>
						</ul>
						<p className={styles.Apply}>Apply Now</p>
						<div className={styles.Wrapper}>
							<div className={styles.Upload}>
								{selectedFile1 ? (
									<label htmlFor="TeacherFile" title={selectedFile1.name}>
										<p className={styles.FileName}>{selectedFile1.name}</p>
									</label>
								) : (
									<label htmlFor="TeacherFile">
										<FiUpload />
										<p>Upload your Resume</p>
									</label>
								)}
							</div>
							<button onClick={handleVacancyUpload} disabled={uploading}>
								{uploading ? "Uploading..." : "Upload"}
							</button>
							<input
								type="file"
								id="TeacherFile"
								accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
								style={{ display: "none" }}
								onChange={(e) => handleChangeFile({ file: e.target.files[0], title: "Teacher" })}
							/>
						</div>
					</div>
					<div className={styles.Right}>
						<img src={C1} alt="" />
					</div>
				</div>

				<div className={styles.RightContainer}>
					<div className={styles.Left}>
						<img src={C2} alt="" />
					</div>
					<div className={styles.Right}>
						<h4>Vacancy for the post of Receptionist</h4>
						<span></span>
						<ul>
							<li>Graduate/ Post Graduate</li>
							<li>Minimum Experience & Skill Requirements</li>
							<li>1-2 Years of working experience in Office Management</li>
							<li>Knowledge of MS- Office</li>
						</ul>
						<p className={styles.Apply}>Apply Now</p>
						<div className={styles.Wrapper}>
							<div className={styles.Upload}>
								{selectedFile2 ? (
									<label htmlFor="ReceptionistFile" title={selectedFile2.name}>
										<p className={styles.FileName}>{selectedFile2.name}</p>
									</label>
								) : (
									<label htmlFor="ReceptionistFile">
										<FiUpload />
										<p>Upload your Resume</p>
									</label>
								)}
							</div>

							<button onClick={handleVacancyUpload} disabled={uploading}>
								{uploading ? "Uploading..." : "Upload"}
							</button>
							<input
								type="file"
								id="ReceptionistFile"
								accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
								style={{ display: "none" }}
								onChange={(e) => handleChangeFile({ file: e.target.files[0], title: "Receptionist" })}
							/>
						</div>
					</div>
				</div>

				<div className={styles.LeftContainer}>
					<div className={styles.Left}>
						<h4>Vacancy for the post of Attendant</h4>
						<span></span>
						<ul>
							<li>Matriculation</li>
							<li>Minimum Experience & Skill Requirements</li>
							<li>1-2 Years of working experience</li>
						</ul>
						<p className={styles.Apply}>Apply Now</p>
						<div className={styles.Wrapper}>
							<div className={styles.Upload}>
								{selectedFile3 ? (
									<label htmlFor="Attendantfile" title={selectedFile3.name}>
										<p className={styles.FileName}>{selectedFile3.name}</p>
									</label>
								) : (
									<label htmlFor="Attendantfile">
										<FiUpload />
										<p>Upload your Resume</p>
									</label>
								)}
							</div>

							<button onClick={handleVacancyUpload} disabled={uploading}>
								{uploading ? "Uploading..." : "Upload"}
							</button>
							<input
								type="file"
								id="Attendantfile"
								accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
								style={{ display: "none" }}
								onChange={(e) => handleChangeFile({ file: e.target.files[0], title: "Attendant" })}
							/>
						</div>
					</div>
					<div className={styles.Right}>
						<img src={C3} alt="" />
					</div>
				</div>

				<div className={styles.RightContainer}>
					<div className={styles.Left}>
						<img src={C4} alt="" />
					</div>
					<div className={styles.Right}>
						<h4>Vacancy for the post of Security Guard</h4>
						<span></span>
						<ul>
							<li>Matriculation</li>
							<li>Minimum Experience & Skill Requirements</li>
							<li>1-2 Years of working experience in Office Management</li>
						</ul>
						<p className={styles.Apply}>Apply Now</p>
						<div className={styles.Wrapper}>
							<div className={styles.Upload}>
								{selectedFile4 ? (
									<label htmlFor="Guardfile" title={selectedFile4.name}>
										<p className={styles.FileName}>{selectedFile4.name}</p>
									</label>
								) : (
									<label htmlFor="Guardfile">
										<FiUpload />
										<p>Upload your Resume</p>
									</label>
								)}
							</div>

							<button onClick={handleVacancyUpload} disabled={uploading}>
								{uploading ? "Uploading..." : "Upload"}
							</button>
							<input
								type="file"
								id="Guardfile"
								accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
								style={{ display: "none" }}
								onChange={(e) => handleChangeFile({ file: e.target.files[0], title: "Security Guard" })}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactUs;
